<template>
    <div class="extralablePage" @mouseleave="isShow=false" @mouseover="isShow=true">
        <div class="lambBtn">
            <div class="icon-lamp"></div>
            <div class="btnmes">GES大会</div>
            <div v-show="isShow" class="mes-box">
                <div class="content">
                    <!-- <img class="content-img" src="https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/news_pic4.png"> -->
                    <button class="confirmBtn" @click="goLink">了解详情</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      isShow: false,
      linkUrl: 'http://www.ges-china.com/2019?code=weilaimofaxiaoxinxichuang'
    }
  },
  methods: {
    goLink () {
      window.open(this.linkUrl, '_blank')
    }
  }
}
</script>
<style scoped lang='scss'>
    .extralablePage{
        .lambBtn{
            background-color: #fff;
            width: 38px;
            height: 105px;
            padding: 12px 11px 12px 12px;
            border-radius: 4px;
            border: 0;
            cursor: pointer;
            z-index: 100;
            transition: all 300ms ease;
            box-shadow:0px 8px 32px 0px rgba(238,238,238,0.6);
            word-break: break-all;
            margin-bottom: 50px;
            position: relative;
            .icon-lamp{
                width: 18px;
                height: 16px;
                background: url('https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/icon-lamb-select.png') no-repeat center;
                background-size: 100% 100%;
                position: relative;
                left: -1px;
            }
            .btnmes{
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 600;
                color: #FF6D00;
                text-align: center;
                border-radius: 20px;
                white-space: normal;
                line-height: 12px;
                margin-top: 7px;
            }
            .mes-box{
                position: absolute;
                top: -150px;
                left: -390px;
                width: 390px;
                /* background: #FF6D00; */
                padding-right: 30px;
                background: transparent;
                .content{
                    width: 100%;
                    height: 540px;
                    background: yellow;
                    border-radius: 10px;
                    background: #fff;
                    padding: 20px;
                    background: url('https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/ges-bg.png');
                    cursor: auto;
                    .confirmBtn{
                        width: 200px;
                        border-radius: 8px;
                        background: #2f4ded;
                        text-align: center;
                        border: none;
                        line-height: 40px;
                        color: #2f4ded;
                        margin-top: 330px;
                        margin-left: 25px;
                        border: 2px solid #2f4ded;
                        box-sizing: border-box;
                        background: transparent;
                        border-radius: 30px;
                        cursor: pointer;
                    }
                    .confirmBtn:hover{
                        background: #2f4ded;
                        color: #fff;
                    }
                }
            }
        }
        .lambBtn:hover{
            color: #fff;
            background: #FF6D00;
            .btnmes{
                color: #fff;
            }
            .icon-lamp{
                background: url('https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/icon-lamb.png') no-repeat center;
                background-size: 100% 100%;
            }
        }
    }
</style>
